
import React from "react";
import { Editor } from "@tiptap/react";
import { AlignLeft, AlignCenter, AlignRight } from "lucide-react";
import MenuButton from "../MenuButton";

interface AlignmentToolsProps {
  editor: Editor;
}

const AlignmentTools = ({ editor }: AlignmentToolsProps) => {
  return (
    <>
      <MenuButton 
        onClick={() => editor.chain().focus().setTextAlign('left').run()} 
        icon={<AlignLeft className="h-4 w-4" />} 
        tooltip="Align Left"
        isActive={editor.isActive({ textAlign: 'left' })}
      />
      <MenuButton 
        onClick={() => editor.chain().focus().setTextAlign('center').run()} 
        icon={<AlignCenter className="h-4 w-4" />} 
        tooltip="Align Center"
        isActive={editor.isActive({ textAlign: 'center' })}
      />
      <MenuButton 
        onClick={() => editor.chain().focus().setTextAlign('right').run()} 
        icon={<AlignRight className="h-4 w-4" />} 
        tooltip="Align Right"
        isActive={editor.isActive({ textAlign: 'right' })}
      />
      
      <div className="h-8 w-px bg-border mx-1" />
    </>
  );
};

export default AlignmentTools;
